// extracted by mini-css-extract-plugin
export var active = "MenuEntry-module--active--3997e";
export var link = "MenuEntry-module--link--5e807";
export var morePaddingLeft = "MenuEntry-module--morePaddingLeft--b2c99";